import type { DbExercise, DbWorkout } from "../types/database";
import { generateId } from "./id";
import { createDefaultExercise as exerciseValidationCreateDefaultExercise } from "./exerciseValidation";

/**
 * Creates a new workout with default values
 */
export function createWorkout(): DbWorkout {
  return {
    id: generateId(),
    user_id: "",
    name: "New Workout",
    description: "",
    exercises: [],
  };
}

/**
 * Creates a new exercise with default values
 */
export function createExercise(type = "strength"): DbExercise {
  return exerciseValidationCreateDefaultExercise(type);
}

/**
 * Export the createDefaultExercise function from exerciseValidation
 */
export { exerciseValidationCreateDefaultExercise as createDefaultExercise };
